import React from "react";
import ReactModal from "react-modal";
import "./ConfirmModal.scss";
class ConfirmModal extends React.Component {
    render() {
        return (
            <ReactModal isOpen={this.props.show} className="confirm-modal">
                <div>
                    <div className="modal-header">
                        <h4 className="text-left">Please Confirm</h4>
                    </div>
                    <div className="error-message">
                        {this.props.error_message}
                    </div>
                    <div className="modal-body">
                        {this.props.showLoader ? (
                            <div className="loader-container">
                                <div className="modal-loader">
                                    <p className="loader">loading..</p>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div>{this.props.confirmText}</div>
                            </div>
                        )}
                    </div>
                    {!this.props.showLoader ? (
                        <div className="modal-footer">
                            <button
                                className="btn cancel-button"
                                onClick={() => this.props.handleClose()}
                            >
                                No
                            </button>
                            <button
                                className="btn confirm-button"
                                onClick={() => this.props.handleConfirm()}
                            >
                                Confirm
                            </button>
                        </div>
                    ) : (
                        <div></div>
                    )}
                </div>
            </ReactModal>
        );
    }
}

export default ConfirmModal;
